'use strict';
/* THIS IS A SHARED COMPONENT. IT IS USED IN BOTH THE ADMIN AND WIDGET */

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Constants = require('ui-addon-avatars/Constants');

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _AvatarSize = require('conversations-core/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'ChatHead',

  propTypes: {
    style: _react.PropTypes.object,
    className: _react.PropTypes.string,
    avatar: _react.PropTypes.string,
    size: _react.PropTypes.string.isRequired,
    onClick: _react.PropTypes.func,
    online: _react.PropTypes.bool.isRequired,
    showStatus: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: _AvatarSize2.default.MEDIUM,
      avatar: _Constants.DEFAULT_CONTACT_AVATAR,
      online: false,
      showStatus: false
    };
  },
  renderStatus: function renderStatus() {
    var _props = this.props,
        online = _props.online,
        showStatus = _props.showStatus;


    if (!showStatus) {
      return null;
    }

    var className = (0, _reactUtils.classNames)('chat-head-status', {
      online: online,
      offline: !online
    });

    return _react2.default.createElement('div', { className: className });
  },
  renderAvatar: function renderAvatar() {
    var _props2 = this.props,
        avatar = _props2.avatar,
        style = _props2.style,
        size = _props2.size;


    return _react2.default.createElement(_UISimpleAvatar2.default, {
      style: style,
      src: avatar,
      className: 'chat-head-avatar',
      size: size
    });
  },
  render: function render() {
    var _props3 = this.props,
        onClick = _props3.onClick,
        className = _props3.className;


    var classes = (0, _reactUtils.classNames)('chat-head', className);
    return _react2.default.createElement(
      'div',
      { className: classes, onClick: onClick },
      this.renderAvatar(),
      this.renderStatus()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/chat/ChatHead.js
// module id = 274
// module chunks = 0 1